/**
 * @typedef {import('./state').ROICalculatorState} ROICalculatorState
 */

import { mutationTypes } from './mutations';

export const actionTypes = {
  UPDATE_CURRENT_STEP: 'UPDATE_CURRENT_STEP',
};

/**
 *
 * @param {keyof actionTypes} actionType
 */
export function action(actionType) {
  return `roiCalculator/${actionType}`;
}

/**
 * @type {import('vuex').ActionTree<ROICalculatorState, ROICalculatorState>}
 */
export const actions = {
  async [actionTypes.UPDATE_CURRENT_STEP]({ commit, state: _state }) {
    commit(mutationTypes.SET_IS_LOADING, true);
  },
};
